module.exports = __webpack_public_path__ + "img/ico_wupinguanli_wupinyouxiaoqiyujing.38fadc2a.png";